/**
 * @generated SignedSource<<e8958262dc9978f35585de21d3e5a618>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Kind = "DISCORD_WEBHOOK" | "SLACK_ALERT" | "SLACK_CHANNEL" | "%future added value";
export type EditDigestJobDialogQuery$variables = {
  jobId: any;
};
export type EditDigestJobDialogQuery$data = {
  readonly node: {
    readonly id?: any;
    readonly inputJson?: any;
    readonly name?: string;
    readonly notificationIntegrations?: ReadonlyArray<{
      readonly id: any;
      readonly kind: Kind;
      readonly name: string;
      readonly slackChannelId: string | null | undefined;
    }>;
    readonly schedule?: any | null | undefined;
  } | null | undefined;
};
export type EditDigestJobDialogQuery = {
  response: EditDigestJobDialogQuery$data;
  variables: EditDigestJobDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jobId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "jobId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inputJson",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schedule",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLNotificationIntegration",
  "kind": "LinkedField",
  "name": "notificationIntegrations",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackChannelId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDigestJobDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "GraphQLJob",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditDigestJobDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "GraphQLJob",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e17c17731a7e0e2bbd586448e7d8095e",
    "id": null,
    "metadata": {},
    "name": "EditDigestJobDialogQuery",
    "operationKind": "query",
    "text": "query EditDigestJobDialogQuery(\n  $jobId: GlobalID!\n) {\n  node(id: $jobId) {\n    __typename\n    ... on GraphQLJob {\n      id\n      name\n      inputJson\n      schedule\n      notificationIntegrations {\n        id\n        name\n        kind\n        slackChannelId\n      }\n    }\n    __isNode: __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4ddef90b330907d8af82cde9fe8afde";

export default node;
